import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Button } from 'antd';
import { MONTH_YEAR_FORMAT, SHORT_MONTH_YEAR_FORMAT, YEAR_FORMAT } from 'const';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { CalendarMiniIcon } from 'components/ui/CalendarMiniIcon';
import dayjs from 'dayjs';
import clsx from 'clsx';
import Styles from './MonthPicker.module.css';

const { MonthPicker } = DatePicker;

const MonthPickerMain = ({
  value,
  setValue,
  className,
  isMobileVersion,
  isYearCalendar,
  ...props
}) => {
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  const deltaTimeStep = isYearCalendar ? 'year' : 'month';

  const getPreviousTimeStep = useCallback(() => {
    setValue(dayjs(value).subtract(1, deltaTimeStep).toISOString());
  }, [value, setValue, deltaTimeStep]);

  const getNextTimeStep = useCallback(() => {
    setValue(dayjs(value).add(1, deltaTimeStep).toISOString());
  }, [value, setValue, deltaTimeStep]);

  const onChange = useCallback(
    (val) => {
      setValue(val.toISOString());
    },
    [setValue]
  );

  const DatePickerComponent = isYearCalendar ? DatePicker : MonthPicker;

  const monthCalendarFormat = isMobileVersion
    ? SHORT_MONTH_YEAR_FORMAT
    : MONTH_YEAR_FORMAT;

  const dateFormat = isYearCalendar ? YEAR_FORMAT : monthCalendarFormat;

  const dayjsValue = value ? dayjs(value) : null;

  return (
    <div className={clsx(Styles.wrapper, className)}>
      <DatePickerComponent
        open={isDatePickerOpen}
        classNames={{ popup: { root: Styles.dropdown } }}
        allowClear={false}
        suffixIcon={<CalendarMiniIcon />}
        size="large"
        format={dateFormat}
        className={Styles.datePicker}
        value={dayjsValue}
        onChange={onChange}
        picker={isYearCalendar ? 'year' : 'month'}
        onOpenChange={(status) => {
          setDatePickerOpen(status);
        }}
        onPanelChange={(v) => {
          onChange(v);
          // setDatePickerOpen(false);
        }}
        {...props}
      />
      {!isMobileVersion && (
        <>
          <Button
            className={Styles.button}
            size="large"
            icon={<LeftOutlined />}
            onClick={getPreviousTimeStep}
          />
          <Button
            className={Styles.button}
            size="large"
            icon={<RightOutlined />}
            onClick={getNextTimeStep}
          />
        </>
      )}
    </div>
  );
};

MonthPickerMain.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setValue: PropTypes.func,
  className: PropTypes.string,
  isMobileVersion: PropTypes.bool,
  isYearCalendar: PropTypes.bool,
};

export { MonthPickerMain as MonthPicker };
